const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式全集阅读',
    desc: '无需翻页，向下滑动即可连贯阅读全部章节，流畅体验让您沉浸于漫画世界，一次性看完整部完结作品。',
  },
  {
    icon: 'ri-book-2-line',
    title: '海量完结漫画大全',
    desc: '收录5000+完结日漫韩漫作品，涵盖热血、恋爱、奇幻、悬疑等多种题材，漫画全集一网打尽。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '免费全集下载',
    desc: '支持漫画全集免费下载，离线也能畅快阅读。无需网络即可享受完整漫画内容，随时随地想看就看。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备流畅适配',
    desc: '桌面端、平板、手机全设备优化，下拉式阅读在不同屏幕尺寸下均保持最佳体验，漫画全集随时随地在线看。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          为什么选择亲亲漫画网
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          专注漫画全集阅读体验，每一个功能都为漫画爱好者精心打造
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat, i) => (
            <div key={i} className="group bg-background-50 border border-background-200 rounded-xl p-6 hover:border-primary-200 transition-colors">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feat.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-800 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}